var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlerta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFD600",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20.5C32 27.1274 26.6274 32.5 20 32.5C13.3726 32.5 8 27.1274 8 20.5C8 13.8726 13.3726 8.5 20 8.5C26.6274 8.5 32 13.8726 32 20.5ZM20 14.5C19.1969 14.5 18.5693 15.1934 18.6493 15.9926L19.1754 21.2537C19.2177 21.6774 19.5742 22 20 22C20.4258 22 20.7823 21.6774 20.8246 21.2537L21.3507 15.9926C21.4307 15.1934 20.8031 14.5 20 14.5ZM20.0023 23.5C19.1739 23.5 18.5023 24.1716 18.5023 25C18.5023 25.8284 19.1739 26.5 20.0023 26.5C20.8307 26.5 21.5023 25.8284 21.5023 25C21.5023 24.1716 20.8307 23.5 20.0023 23.5Z",
    fill: "#D8B500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerta);
export default __webpack_public_path__ + "static/media/alerta.2aea451fc83cf5c263445168ec82e40f.svg";
export { ForwardRef as ReactComponent };